<template>
  <div class="more">
    <img
      class="more-icon"
      :src="getComputedSrc(showMore)"
      alt=""
      @click="handleMore"
    />
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';

const topArrow = 'https://res.pandateacher.com/ZAOQOE4K1632280279350.png';
const bottomArrow = 'https://res.pandateacher.com/1FO987IV1632280448634.png';
@Component({
  components: {},
})
export default class ShowMore extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })
  showMore!: boolean;

  get getComputedSrc() {
    return (showMore: boolean) => {
      return showMore ? bottomArrow : topArrow;
    };
  }

  handleMore() {
    this.$emit('handleMore');
  }
}
</script>


<style lang="scss" scoped>
.more {
  margin: 16px 0;
  text-align: center;
  .more-icon {
    display: inline-block;
    width: 40px;
    height: 40px;
  }
}
</style>